import styled from "styled-components";

export const Section = styled.section`
  background-color: ${({ theme }) => theme.customTheme.palette.white.standard};
  background-position: center;
  background-size: cover;
`;
